import axios from 'axios'
import {BUSCAR_FECHAMENTOS_CAIXA} from '../../types'
import {SLOW_REQUEST_CONFIG} from '../../../util/loadingUtil'
import {URL} from '../../../util/ambienteActions';
import {montarURLFiltro} from '../../../util/filtros';

export default function buscarFechamentosCaixa(idEmpresa, pagina, registrosPorPagina, filtros) {
    const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);

    const url = `${URL}/fechamento-caixa-usuario/empresa/${idEmpresa}${urlFiltros}`;
    return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: BUSCAR_FECHAMENTOS_CAIXA,
            payload: response

        })
    );
}
